import { render, staticRenderFns } from "./UserImportModal.vue?vue&type=template&id=d97032a4&"
import script from "./UserImportModal.vue?vue&type=script&lang=js&"
export * from "./UserImportModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports